// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"946e6524","581":"80796228"}[chunkId] + ".chunk.js";
};